jQuery(function () {

	/**
	 * Copy debug info to clipboard when the button is clicked.
	 */
	jQuery("#debug-info-button").on("click", () => {
		// Select text in textarea
		const textarea = jQuery("#debug-info-textarea")[0];
		textarea.select();
		textarea.setSelectionRange(0, 99999); // For mobile devices

		// Copy selected text to clipboard
		pmw.copyTextToClipboard(jQuery("#debug-info-textarea").val());

		// Show success message and hide after 3 seconds
		const successElement = jQuery("#debug-info-success");
		successElement.fadeIn(200);
		setTimeout(() => successElement.fadeOut(200), 3000);
	});

	jQuery("#pmw-pro-version-demo").on("click", function () {
		jQuery("#submit").trigger("click");
	});

	if (document.getElementById("json-settings-file-input")) {
		document.getElementById("json-settings-file-input")
			.addEventListener("change", pmw.readSettingsFile, false);
	}

	// if element ga4-data-api-credentials-upload-button exists, then we are on the GA4 settings page
	if (document.getElementById("ga4-data-api-credentials-upload-button")) {

		document.getElementById("ga4-data-api-credentials-upload-button")
			.addEventListener("change", pmw.readGa4DataApiCredentials, false);
	}

	// if element ga4-data-api-credentials-upload-button exists, then we are on the GA4 settings page
	if (document.getElementById("ga4-data-api-credentials-delete-button")) {

		document.getElementById("ga4-data-api-credentials-delete-button")
			.addEventListener("click", () => {
				pmw.saveGa4DataApiCredentialsToDb({});
			}, false);
	}

	/**
	 * Handle log files download via REST API
	 */
	jQuery("#wgact_download_logs_zip").on("click", function(e) {
		e.preventDefault();
		
		if (jQuery(this).prop("disabled")) {
			return;
		}
		
		const source = jQuery(this).data("source");
		const button = jQuery(this);
		const originalText = button.text();
		
		// Disable button and change text
		button.prop("disabled", true).text("Downloading...");
		
		// Use fetch with proper authentication
		fetch(pmwAdminApi.root + "pmw/v1/logs/download", {
			method: "POST",
			headers: {
				"Content-Type": "application/x-www-form-urlencoded",
				"X-WP-Nonce": pmwAdminApi.nonce
			},
			body: new URLSearchParams({
				source: source
			}),
			credentials: 'same-origin'
		})
		.then(response => {
			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}
			return response.blob();
		})
		.then(blob => {
			// Create download link
			const url = window.URL.createObjectURL(blob);
			const a = document.createElement("a");
			a.href = url;
			a.download = "pmw-logs-" + new Date().toISOString().slice(0,19).replace(/:/g, "-") + ".zip";
			document.body.appendChild(a);
			a.click();
			window.URL.revokeObjectURL(url);
			document.body.removeChild(a);
			
			// Re-enable the button
			button.prop("disabled", false).text(originalText);
		})
		.catch(error => {
			console.error("Download error:", error);
			button.prop("disabled", false).text(originalText);
			alert("Error downloading log files. Please try again.");
		});
	});
});

// jQuery(function () {
//
// 	import("../../../node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs")
// 		.then(({
// 				   computePosition,
// 				   flip,
// 				   shift,
// 				   offset,
// 			arrow,
// 			   }) => {
// 			console.log("computePosition: ", computePosition)
//
// 			const button = document.querySelector('#button');
// 			const tooltip = document.querySelector('#tooltip');
// 			const arrowElement = document.querySelector('#arrow');
//
// 			computePosition(button, tooltip, {
// 				placement: 'top',
// 				middleware: [
// 					offset(6),
// 					flip(),
// 					shift({padding: 5}),
// 					arrow({element: arrowElement}),
// 				],
// 			}).then(({x, y}) => {
// 				Object.assign(tooltip.style, {
// 					left: `${x}px`,
// 					top: `${y}px`,
// 				});
// 			});
//
// 		})
// 		.catch(err => {
// 			console.error(err)
// 		})
//
// });


(function (pmw, $, undefined) {

	pmw.saveSettingsToDisk = () => {
		let text = document.getElementById("export-settings-json").value;

		// Extract timestamp from the settings JSON
		let timestamp = "unknown";
		try {
			let settings = JSON.parse(text);
			if (settings.timestamp) {
				timestamp = settings.timestamp;
			}
		} catch (error) {
			console.warn("Could not extract timestamp from settings:", error);
		}

		text                 = text.replace(/\n/g, "\r\n"); // To retain the Line breaks.
		let blob             = new Blob([text], {type: "text/plain"});
		let anchor           = document.createElement("a");
		anchor.download      = "pixel-manager-settings_" + timestamp + "_" + pmw.getDateTimeFromTimestamp(timestamp) + ".json";
		anchor.href          = window.URL.createObjectURL(blob);
		anchor.target        = "_blank";
		anchor.style.display = "none"; // just to be safe!
		document.body.appendChild(anchor);
		anchor.click();
		document.body.removeChild(anchor);
	};

	// Get date and time from timestamp in year.month.day_hour-minute-second format. All components are zero padded.
	// Uses WordPress site timezone to match what's displayed on admin pages.
	pmw.getDateTimeFromTimestamp = (timestamp) => {
		// If timestamp is "unknown" or invalid, fall back to current date/time
		if (timestamp === "unknown" || !timestamp || isNaN(timestamp)) {
			return pmw.getCurrentDateForFileName();
		}

		// Convert Unix timestamp (seconds) to milliseconds for JavaScript Date
		let date = new Date(timestamp * 1000);

		// Apply WordPress timezone offset if available
		if (pmwAdminApi && pmwAdminApi.timezone && typeof pmwAdminApi.timezone.offset === "number") {
			// Create new date in WordPress timezone by adding the offset
			let wpTimezoneOffsetMs = pmwAdminApi.timezone.offset * 60 * 60 * 1000; // Convert hours to milliseconds
			date                   = new Date(date.getTime() + wpTimezoneOffsetMs);

			// Get WordPress timezone date/time components using UTC methods
			// (since we've already applied the offset to the date object)
			let year    = date.getUTCFullYear();
			let month   = ("0" + (date.getUTCMonth() + 1)).slice(-2);
			let day     = ("0" + date.getUTCDate()).slice(-2);
			let hours   = ("0" + date.getUTCHours()).slice(-2);
			let minutes = ("0" + date.getUTCMinutes()).slice(-2);
			let seconds = ("0" + date.getUTCSeconds()).slice(-2);

			return year + "." + month + "." + day + "_" + hours + "-" + minutes + "-" + seconds;
		} else {
			// Fallback to browser local timezone if WordPress timezone data is not available
			let year    = date.getFullYear();
			let month   = ("0" + (date.getMonth() + 1)).slice(-2);
			let day     = ("0" + date.getDate()).slice(-2);
			let hours   = ("0" + date.getHours()).slice(-2);
			let minutes = ("0" + date.getMinutes()).slice(-2);
			let seconds = ("0" + date.getSeconds()).slice(-2);
			return year + "." + month + "." + day + "_" + hours + "-" + minutes + "-" + seconds;
		}
	};

	// Get current date and time in year.month.day_hour-minute-second format. All components are zero padded.
	// Uses WordPress site timezone to match what's displayed on admin pages.
	pmw.getCurrentDateForFileName = () => {
		let date = new Date();

		// Apply WordPress timezone offset if available
		if (pmwAdminApi && pmwAdminApi.timezone && typeof pmwAdminApi.timezone.offset === "number") {
			// Apply WordPress timezone offset
			let wpTimezoneOffsetMs = pmwAdminApi.timezone.offset * 60 * 60 * 1000; // Convert hours to milliseconds
			date                   = new Date(date.getTime() + wpTimezoneOffsetMs);

			// Get WordPress timezone date/time components using UTC methods
			// (since we've already applied the offset to the date object)
			let year    = date.getUTCFullYear();
			let month   = ("0" + (date.getUTCMonth() + 1)).slice(-2);
			let day     = ("0" + date.getUTCDate()).slice(-2);
			let hours   = ("0" + date.getUTCHours()).slice(-2);
			let minutes = ("0" + date.getUTCMinutes()).slice(-2);
			let seconds = ("0" + date.getUTCSeconds()).slice(-2);

			return year + "." + month + "." + day + "_" + hours + "-" + minutes + "-" + seconds;
		} else {
			// Fallback to browser local timezone if WordPress timezone data is not available
			let year    = date.getFullYear();
			let month   = ("0" + (date.getMonth() + 1)).slice(-2);
			let day     = ("0" + date.getDate()).slice(-2);
			let hours   = ("0" + date.getHours()).slice(-2);
			let minutes = ("0" + date.getMinutes()).slice(-2);
			let seconds = ("0" + date.getSeconds()).slice(-2);
			return year + "." + month + "." + day + "_" + hours + "-" + minutes + "-" + seconds;
		}

		// return date.toLocaleDateString(
		// 	"en-US", {
		// 		year : "numeric",
		// 		month: "2-digit",
		// 		day  : "2-digit",
		// 	},
		// )
	};

	pmw.readSettingsFile = e => {

		let file = e.target.files[0];
		if (!file) return;
		let reader    = new FileReader();
		reader.onload = function (e) {

			// Check if the file is a valid JSON file
			// If it is not a valid JSON file, display an error message
			try {
				JSON.parse(e.target.result);
			} catch (error) {
				document.getElementById("settings-upload-status-error").style.display     = "block";
				document.getElementById("settings-upload-status-error-message").innerHTML = "Invalid JSON file.";
				return;
			}

			let contents = JSON.parse(e.target.result);

			// document.getElementById("import-settings-json").textContent = JSON.stringify(contents)

			pmw.saveImportedSettingsToDb(contents);
		};
		reader.readAsText(file);
	};

	pmw.saveImportedSettingsToDb = settings => {

		fetch(pmwAdminApi.root + "pmw/v1/settings/", {
			method     : "POST",
			credentials: "same-origin",
			headers    : {
				"Content-Type": "application/json",
				"X-WP-Nonce"  : pmwAdminApi.nonce,
			},
			body       : JSON.stringify(settings),
		})
			.then(response => response.json())
			.then(async message => {
				if (message.success) {
					console.log(message);
					// reload window
					document.getElementById("settings-upload-status-success").style.display = "block";
					// wait 5 seconds
					await new Promise(resolve => setTimeout(resolve, 1000));
					window.location.reload();
				} else {
					console.log(message);
					document.getElementById("settings-upload-status-error").style.display = "block";
				}
			})
			.catch(error => {
				console.error(error);
				document.getElementById("settings-upload-status-error").style.display = "block";
			});
	};

	pmw.restoreBackup = (timestamp) => {

		console.log("restoreBackup() - timestamp: ", timestamp);

		fetch(pmwAdminApi.root + "pmw/v1/options-backup/" + timestamp + "/restore", {
			method     : "POST",
			credentials: "same-origin",
			headers    : {
				"Content-Type": "application/json",
				"X-WP-Nonce"  : pmwAdminApi.nonce,
			},
		})
			.then(response => response.json())
			.then(async message => {

				if (message?.data?.message) {
					console.log("restoreBackup() - message: ", message.data.message);
				}

				if (message.success) {
					window.location.reload();
				} else {
					alert(message.data.message);
				}

			})
			.catch(error => {
				console.error(error);
				alert(error.message);
			});
	};

	pmw.readGa4DataApiCredentials = e => {

		let file = e.target.files[0];
		if (!file) return;
		let reader    = new FileReader();
		reader.onload = function (e) {

			// Check if the file is a valid JSON file
			// If it is not a valid JSON file, display an error message
			try {
				JSON.parse(e.target.result);
			} catch (error) {
				document.getElementById("ga4-api-credentials-upload-status-error").style.display     = "block";
				document.getElementById("ga4-api-credentials-upload-status-error-message").innerHTML = "Invalid JSON file.";
				return;
			}

			let contents = JSON.parse(e.target.result);

			// document.getElementById("import-settings-json").textContent = JSON.stringify(contents)

			pmw.saveGa4DataApiCredentialsToDb(contents);
		};
		reader.readAsText(file);
	};

	pmw.deleteGa4DataApiCredentials = e => {
		pmw.saveGa4DataApiCredentialsToDb({});
	};

	pmw.saveGa4DataApiCredentialsToDb = credentials => {

		fetch(pmwAdminApi.root + "pmw/v1/ga4/data-api/credentials", {
			method     : "POST",
			credentials: "same-origin",
			headers    : {
				"Content-Type": "application/json",
				"X-WP-Nonce"  : pmwAdminApi.nonce,
			},
			body       : JSON.stringify(credentials),
		})
			.then(response => response.json())
			.then(async responseJson => {
				if (responseJson.success) {
					console.log(responseJson);
					// reload window
					document.getElementById("ga4-api-credentials-upload-status-success").style.display = "block";
					// wait 5 seconds
					// await new Promise(resolve => setTimeout(resolve, 5000))
					window.location.reload();
				} else {
					console.log(responseJson);
					document.getElementById("ga4-api-credentials-upload-status-error").style.display     = "block";
					// and add the error message
					document.getElementById("ga4-api-credentials-upload-status-error-message").innerHTML = "Error message: " + responseJson.data.message;
				}
			})
			.catch(error => {
				console.error(error);
				document.getElementById("ga4-api-credentials-upload-status-error").style.display = "block";
			});
	};

	pmw.getAiBotUrl = () => {
		if (pmw_cody?.url) {
			return pmw_cody.url;
		}
	};

	/**
	 * Opens the chatbot in a side panel (like n8n)
	 * The panel slides in from the right side of the screen
	 */
	pmw.loadAiChatWindow = () => {
		const panel = document.getElementById("pmw-chatbot-panel");
		const iframe = document.getElementById("pmw-chatbot-iframe");

		if (!panel || !iframe) {
			console.error("Chatbot panel elements not found");
			return;
		}

		// Set the iframe source
		iframe.src = pmw.getAiBotUrl();

		// Add body class to push content left
		document.body.classList.add("pmw-chatbot-open");

		// Open the panel
		panel.classList.add("pmw-chatbot-panel-open");
	};

	/**
	 * Closes the chatbot side panel
	 */
	pmw.closeChatbot = () => {
		const panel = document.getElementById("pmw-chatbot-panel");
		if (panel) {
			panel.classList.remove("pmw-chatbot-panel-open");
			// Remove body class to restore content position
			document.body.classList.remove("pmw-chatbot-open");
		}
	};

	/**
	 * Check if the Cody AI chatbot is available.
	 *
	 * @return {boolean}
	 */
	pmw.codyAvailable = () => {
		if (typeof window.pmw_cody !== "undefined" && window.pmw_cody?.available) {
			return true;
		}
		return false;
	};

	// Schedule a recalculation of the LTV by sending a POST REST request to the server
	pmw.ltvRecalculation = event => {

		const displayStatusMessage = (message) => {
			let elements = document.getElementsByClassName("ltv-message");
			for (let i = 0; i < elements.length; i++) {
				elements[i].style.display = "none";
			}
			document.getElementById("ltv-message-error").style.display  = "block";
			document.getElementById("ltv-message-error-text").innerHTML = message;
		};

		const displayRunImmediatelyButton = () => {
			let elements = document.getElementsByClassName("ltv-button-text");
			for (let i = 0; i < elements.length; i++) {
				elements[i].style.display = "none";
			}
			document.getElementById("ltv-instant-recalculation-button-text").style.display = "block";
		};

		const removeAllMessages = () => {
			let elements = document.getElementsByClassName("ltv-message");
			for (let i = 0; i < elements.length; i++) {
				elements[i].style.display = "none";
			}

			document.getElementById("ltv-message-error").style.display = "none";
		};

		// console log the data-action from the nested span element of the clicked element
		// console.log("event.target.dataset.action", event.target.dataset.action)

		fetch(pmwAdminApi.root + "pmw/v1/ltv/", {
			method     : "POST",
			credentials: "same-origin",
			headers    : {
				"Content-Type": "application/json",
				"X-WP-Nonce"  : pmwAdminApi.nonce,
			},
			body       : JSON.stringify({
				"action": event.target.dataset.action,
			}),
		})
			.then(response => response.json())
			.then(message => {
				if (message.success) {
					console.log(message);
					// reload window

					if (message.data.status.is_scheduled) {
						removeAllMessages();
						displayRunImmediatelyButton();
						document.getElementById("ltv-schedule-recalculation-confirmation-message").style.display = "block";
					}

					if (message.data.status.is_running) {
						// Get the button element with the id "wgact_ltv_recalculation" and disable it
						document.getElementById("wgact_ltv_recalculation").disabled = true;
						removeAllMessages();
						document.getElementById("ltv-running-recalculation-confirmation-message").style.display = "block";
					}

					// if is neither message.data.status.is_running nor message.data.status.is_scheduled
					// then display the error message
					if (!message.data.status.is_running && !message.data.status.is_scheduled) {
						displayStatusMessage(message.data.message);
					}
				} else {
					console.error(message);
					displayStatusMessage(message.data.message);
				}
			})
			.catch(error => {
				console.error(error);
				displayStatusMessage(error);
			});
	};

	pmw.copyTextToClipboard = (text) => {
		navigator.clipboard.writeText(text)
			.catch(err => {
				console.error("Failed to copy: ", err);
			});
	};

}(window.pmw = window.pmw || {}, jQuery));

/**
 * This script listens for the DOMContentLoaded event. Once the DOM is fully loaded,
 * it checks if the chatbot (pmw.codyAvailable()) is available.
 * If the chatbot is available, it displays the chat widget button.
 * If the chatbot is not available, it logs a message to the console indicating that the chatbot is unavailable.
 *
 * @listens document#DOMContentLoaded
 */
document.addEventListener("DOMContentLoaded", () => {

	if (pmw.codyAvailable()) {
		const chatbotWidget = document.getElementById("pmw-chatbot-widget");
		if (chatbotWidget) {
			chatbotWidget.style.display = "block";
		}

		// Show the chatbot line in the support section
		const chatbotListItem = document.getElementById("pmw-chat-li");
		if (chatbotListItem) {
			chatbotListItem.style.display = "list-item";
		}

		// Set up event listeners for the chatbot widget
		const chatbotToggle = document.getElementById("pmw-chatbot-toggle");
		const chatbotClose = document.getElementById("pmw-chatbot-close");

		if (chatbotToggle) {
			chatbotToggle.addEventListener("click", (e) => {
				e.preventDefault();
				pmw.loadAiChatWindow();
			});
		}

		if (chatbotClose) {
			chatbotClose.addEventListener("click", (e) => {
				e.preventDefault();
				pmw.closeChatbot();
			});
		}

		// Close chatbot on ESC key
		document.addEventListener("keydown", (event) => {
			if (event.key === "Escape") {
				pmw.closeChatbot();
			}
		});
	} else {
		console.log("DOMContentLoaded - chatbot is not available");
	}

}, true);

// Wait until the DOM is loaded, then console log
// the message "DOMContentLoaded - chatbot is not available"
// use jquery
jQuery(() => {
	if (document.querySelector("#wgact_ltv_recalculation")) {
		document.querySelector("#wgact_ltv_recalculation").addEventListener("click", event => {
			event.preventDefault();
			pmw.ltvRecalculation(event);
		});
	}

	if (document.querySelector("#pmw_stop_ltv_calculation")) {
		document.querySelector("#pmw_stop_ltv_calculation").addEventListener("click", event => {
			event.preventDefault();
			pmw.ltvRecalculation(event);
		});
	}

	// Add event listeners for backup restore buttons
	jQuery(() => {
		jQuery(document).on("click", ".pmw-restore-backup-button", function (event) {
			event.preventDefault();
			const timestamp = jQuery(this).data("timestamp");
			if (timestamp) {
				pmw.restoreBackup(timestamp);
			}
		});
	});
});

/**
 * add an event listener to the button with the id "wgact_copy_log_file_links"
 * when the button is clicked, copy the log file links to the clipboard
 * the data-links attribute of the button contains a json string with the links
 */
jQuery(() => {

	if (!document.querySelector("#wgact_copy_log_file_links")) {
		return;
	}

	document.querySelector("#wgact_copy_log_file_links").addEventListener("click", event => {
		event.preventDefault();

		const jsonOfLinks = JSON.parse(event.target.dataset.links);

		let strOfLinks = "";

		for (let i = 0, len = jsonOfLinks.length; i < len; i++) {
			strOfLinks += jsonOfLinks[i] + "\n";
		}

		pmw.copyTextToClipboard(strOfLinks);

		// make the button text change to "Copied!" and keep the same width and text for 3 seconds
		let button         = document.getElementById("wgact_copy_log_file_links");
		button.style.width = getComputedStyle(button).width;
		const originalText = button.innerHTML;
		button.innerHTML   = event.target.dataset.textCopied;
		setTimeout(function () {
			button.innerHTML = originalText;
		}, 3000);
	});
});

// on pressing enter in form inputs, click the submit button
jQuery(() => {
	jQuery(document).on("keydown", "input, textarea, select", function (event) {
		if (event.key === "Enter" && !event.shiftKey && !event.ctrlKey && !event.altKey) {
			// Only trigger submit if we're in a form and not in a textarea (where Enter should create new lines)
			const $target = jQuery(event.target);
			if ($target.is("input") && $target.closest("form").length > 0) {
				const form = $target.closest("form")[0];
				const submitButton = jQuery(form).find("#submit");
				if (submitButton.length > 0) {
					event.preventDefault();
					submitButton.click();
				}
			}
		}
	});
});
